__turbopack_context__.v({
  "blocksBackgroundColor": "SearchPage-module-scss-module__JUQfCG__blocksBackgroundColor",
  "blocksContainer": "SearchPage-module-scss-module__JUQfCG__blocksContainer",
  "blocksFontColor": "SearchPage-module-scss-module__JUQfCG__blocksFontColor",
  "blocksFooter": "SearchPage-module-scss-module__JUQfCG__blocksFooter",
  "collapseBar": "SearchPage-module-scss-module__JUQfCG__collapseBar",
  "container": "SearchPage-module-scss-module__JUQfCG__container",
  "filtersContainer": "SearchPage-module-scss-module__JUQfCG__filtersContainer",
  "filtersContainerExpanded": "SearchPage-module-scss-module__JUQfCG__filtersContainerExpanded",
  "filtersList": "SearchPage-module-scss-module__JUQfCG__filtersList",
  "filtersListExpanded": "SearchPage-module-scss-module__JUQfCG__filtersListExpanded",
  "filtersListSearch": "SearchPage-module-scss-module__JUQfCG__filtersListSearch",
  "filtersListSearchExpanded": "SearchPage-module-scss-module__JUQfCG__filtersListSearchExpanded",
  "initialContainer": "SearchPage-module-scss-module__JUQfCG__initialContainer",
  "loadingContainer": "SearchPage-module-scss-module__JUQfCG__loadingContainer",
  "mobileSearchFilterGrabBar": "SearchPage-module-scss-module__JUQfCG__mobileSearchFilterGrabBar",
  "onPageSearchBox": "SearchPage-module-scss-module__JUQfCG__onPageSearchBox",
  "pageResultsContainer": "SearchPage-module-scss-module__JUQfCG__pageResultsContainer",
  "search": "SearchPage-module-scss-module__JUQfCG__search",
  "secondaryNavBackgroundColor": "SearchPage-module-scss-module__JUQfCG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "SearchPage-module-scss-module__JUQfCG__themeBackgroundColor",
  "themeFontColor": "SearchPage-module-scss-module__JUQfCG__themeFontColor",
});
